<template>
  <div>
    <div class="ellipsis-cell-outer d-none d-sm-flex">
      <div class="ellipsis-cell-inner">
        <slot />
      </div>
    </div>
    <div class="d-flex d-sm-none">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EllipsisCell'
}
</script>

<style scoped>
  .ellipsis-cell-outer {
    position: relative;
    height: 1.5em;
  }

  .ellipsis-cell-inner {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>